import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import "./_assets/css/animate.css";
import "./_assets/css/bootstrap.css";
import "./_assets/css/bootstrap.min.css";
import "./_assets/css/fontawesome-all.css";
import "./_assets/css/style.css";
import "./_assets/css/custom.css";
import "./_assets/css/responsive.css";



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);